"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriftDataGrid = void 0;
const material_1 = require("@mui/material");
const x_data_grid_pro_1 = require("@mui/x-data-grid-pro"); // to maintain backward compatability with unlicensed DataGrid
const { 'cell--editable': cellEditable, 'columnHeader--sortable': columnHeaderSortable, 'columnHeader--sorted': columnHeaderSorted, cell, columnHeader, columnHeaderDraggableContainer, columnHeaderTitleContainer, footerContainer, iconButtonContainer, root, sortIcon, } = x_data_grid_pro_1.gridClasses;
exports.DriftDataGrid = (0, material_1.styled)(x_data_grid_pro_1.DataGridPro)(({ theme }) => ({
    [`.${material_1.linearProgressClasses.root}`]: {
        backgroundColor: 'transparent',
        height: '2px',
    },
    [`.${root}`]: {
        borderColor: theme.palette.gray[300],
        [`.${columnHeader}, .${cell}`]: {
            padding: '0 20px',
        },
    },
    [`.${columnHeaderSortable}:hover`]: {
        [`.${iconButtonContainer}`]: {
            visibility: 'hidden',
        },
    },
    [`.${cellEditable}`]: {
        border: `1px solid ${theme.palette.gray[500]}`,
        borderRadius: '4px',
        height: '40px',
        margin: 'auto',
        marginLeft: '2px',
        marginRight: '2px',
        display: 'flex',
        alignItems: 'center',
    },
    [`.${columnHeader}`]: {
        cursor: 'default',
        height: '60px !important',
        [`.${material_1.buttonBaseClasses.root}:hover`]: {
            background: 'inherit',
        },
        [`& .${columnHeaderTitleContainer}`]: {
            cursor: 'pointer',
            paddingRight: '4px',
            paddingLeft: '12px',
            height: '2rem',
            marginTop: '14px',
            flex: 'unset',
            borderRadius: '2rem',
            marginLeft: '-0.5rem',
            '&:hover': {
                backgroundColor: theme.palette.gray[200],
                [`.${iconButtonContainer}`]: {
                    visibility: 'visible',
                },
            },
        },
        '&--alignRight': {
            [`& .${columnHeaderTitleContainer}`]: {
                paddingRight: '12px',
                paddingLeft: '4px',
                marginLeft: '0',
                marginRight: '-0.5rem',
            },
        },
        '&--alignCenter': {
            [`& .${columnHeaderTitleContainer}`]: {
                paddingRight: '12px',
                paddingLeft: '12px',
                marginLeft: '0',
                marginRight: '0',
            },
            [`& .${columnHeaderDraggableContainer}`]: {
                justifyContent: 'center',
            },
        },
        [`&.${columnHeaderSorted}`]: {
            [`.${iconButtonContainer}`]: {
                visibility: 'visible',
            },
            [`& .${sortIcon}`]: {
                color: theme.palette.blue[500],
            },
            [`& .${columnHeaderTitleContainer}`]: {
                backgroundColor: theme.palette.blue[100],
                color: theme.palette.blue[500],
            },
        },
    },
    [`& .${footerContainer}`]: {
        backgroundColor: theme.palette.background.default,
    },
}));
//# sourceMappingURL=DriftDataGrid.js.map